import React from 'react'

type Props = {}

const CursorIcon = (props: Props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 96.000000 96.000000"
      preserveAspectRatio="xMidYMid meet">
      <g
        transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="black"
        stroke-width="29">
        <path
          d="M271 846 c-9 -11 -11 -97 -5 -376 7 -366 10 -390 44 -390 5 0 41 28
      80 63 39 34 91 79 115 101 l44 38 140 8 c143 8 171 16 171 49 0 23 -526 515
      -555 519 -12 2 -27 -4 -34 -12z"
        />
      </g>
    </svg>
  )
}

export default CursorIcon
